import {combineReducers} from "redux";

import brand from "slices/brandSlice";

import config from "./configSlice";
import userPersona from "./userPersonaSlice";
import submitForm from "./submitFormSlice";
import attachments from "./attachmentSlice";
import geo from "./geoSlice";
import appMode from "./appModeSlice";

export default combineReducers({
    config,
    userPersona,
    submitForm,
    attachments,
    geo,
    brand,
    appMode,
});
